export const articlesConstants = {
  CREATED_ARTICLE: 'CREATED_ARTICLE',
  UPDATED_ARTICLE: 'UPDATED_ARTICLE',
  FETCHED_ARTICLE: 'FETCHED_ARTICLE',
  LISTED_ARTICLES: 'LISTED_ARTICLES'
};
